export const formatNumber = x => {
    try {
        const xNum = Number(x)
        return isNaN(xNum)
            ? x : xNum.toLocaleString()
    }
    catch(_) {
        return x
    }
}

const dollarFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

export const formatDollars = (x, {includeZeroDecimal = true} = {}) => {
    try {
        const xNum = Number(x)

        const result = isNaN(xNum)
            ? x
            : dollarFormatter.format(x)

        return includeZeroDecimal
            ? result
            : result.replace(/\.00$/, '')
    }
    catch(_) {
        return x
    }
}

// copied from https://stackoverflow.com/a/11832950/1526406.  Apparently it isn't perfect, but good enough (would be like $0.01 off at worst)
export const roundTwoDigits = num => Math.round((num + Number.EPSILON) * 100) / 100

export const getEnding = (howManyChars, x) => {
    if(x === null || x === undefined || !x.toString()) return ''

    x = x.toString()

    return x.substr(-1 * howManyChars)
}
